import { t } from 'i18next';
import React from 'react';
import { IConversationMessage } from 'src/types/serviceResponseTypes';
import styles from './UserChatBubble.module.scss';

type UserChatBubblePropType = {
  conversation: IConversationMessage;
  hideFromScreenReader?: boolean;
};

function UserChatBubble(props: UserChatBubblePropType) {
  const { conversation, hideFromScreenReader } = props;

  return (
    <div
      tabIndex={0}
      aria-hidden={hideFromScreenReader || undefined}
      className='flex flex-col justify-end self-end mb-space-6'
    >
      <span className='sr-only' aria-live='polite'>
        {t('YOU')}: {t('MESSAGE_SENT')}
      </span>
      <p className={`relative px-space-4 bg-secondary-container border border-solid border-[var(--border-outline-variant)] py-space-4 rounded-2xl rounded-br-none text-main ${styles.userMessage}`}>
        <span>{conversation.content}</span>
      </p>
    </div>
  );
}

export default UserChatBubble;
